export default function setLongAction(longitude) {
    return {
        type: 'SET_LONG',
        payload: longitude
    }
}